import {Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField, useTheme} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../context/OperationContext";
import StatusReportAction from "../../service/statusreport.actions";
import GenericFilterBox from "../common/GenericFilterBox";
import ManipulateLocation, { LocationType } from "./ManipulateLocation";
import { vehicleActions } from "../../service/vehicle.actions";

const StatusReportFilterAndSearch = (props: any) => {
  const theme = useTheme();
  const {filterData, setFilterData, resetData, refreshTable, setRefreshTable} = props;

  const { t, i18n } = useTranslation(["operation"]);
  const statusReportAction = StatusReportAction();
  const manipulateLoc = ManipulateLocation();
  const [locationValues, setLocationValues] = useState<LocationType[]>([]);
  const [tractionValues, setTractionValues] = useState<any>([]);
  const [statusReport, setStatusReport] = useState<any[]>([]);

  const { userLocations, locationsLoading, setLoading } = useContext(ContextOperation);
  
  const [carSegment, setCarSegment] = useState<any>([]);
  const [carClass, setCarClass] = useState<any>([]);
  const [acriss, setAcriss] = useState<any>([]);

  const vehicleAction = vehicleActions();

  const changeNameLocationType = (name: string) => {
    switch (name) {
      case "PARKING_GO":
        return t("internOptionSelectName.physicalLocationType.parkingGo");
      case "LMS":
        return t("internOptionSelectName.physicalLocationType.lms");
      case "COMPOUND":
        return t("internOptionSelectName.physicalLocationType.compound");
      case "SHOP_REPAIR":
        return t("internOptionSelectName.physicalLocationType.shopRepair");
      case "CONTRACTOR":
        return t("internOptionSelectName.physicalLocationType.contractor");
      case "CARRIER":
        return t("internOptionSelectName.physicalLocationType.carrier");
      case "INTERMEDIARY":
        return t("internOptionSelectName.physicalLocationType.intermediary");
      case "AFFILIATE":
        return t("internOptionSelectName.physicalLocationType.affiliate");
      default:
        return name;
    }
  };
  const handleChange = (e: any) => {
    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };
  
  const handleChangeSpec = (event: any, type: any) => {
    setFilterData({
      ...filterData,
      [type]: {
        ...filterData?.[type],
        id: event?.id ? event?.id : "",
        descr: event?.descr ? event?.descr : "",
      },
    });
  };

  const handleChangeAcriss = (event: any, type: any) => {

    setFilterData({
      ...filterData,
      [type]: {
        ...filterData?.[type],
        id: event?.id ? event?.id : "",
        code: event?.code ? event?.code : "",
      },
    });

  };


  const handleChangePhysicalLocationType = (value: any, name: any) => {

    let newFilterData = {
      ...filterData,
      [name]: {
        ...filterData?.[name],
        id: value?.id ? value?.id : "",
        descr: value?.descr ? value?.descr : "",
      },
    }

    if (name === "referenceLocationId") {
      newFilterData = {
        ...newFilterData,
        referenceLocationType: value.typeEnum,
      };
    }

    setFilterData(newFilterData);
  };

  const Search = (event: any) => {
    event.preventDefault();
    setRefreshTable(!refreshTable);
  };

  const statusType = [
    { id: "AVAILABLE", descr: t("internOptionSelectName.available") },
    { id: "NOT_AVAILABLE", descr: t("internOptionSelectName.notAvailable") },
  ];

  const checkinEstimatedLocationType = [
    {
      id: "PARKING_GO",
      descr: t("internOptionSelectName.physicalLocationType.parkingGo"),
    },
    { id: "LMS", descr: t("internOptionSelectName.physicalLocationType.lms") },
    {
      id: "COMPOUND",
      descr: t("internOptionSelectName.physicalLocationType.compound"),
    },
    {
      id: "SHOP_REPAIR",
      descr: t("internOptionSelectName.physicalLocationType.shopRepair"),
    },
  ];

  const endpointData = () => {
    statusReportAction.getAllTractionTypeData().then((response) => {
        setTractionValues(managerTractionData(response));
    });
    statusReportAction.getAllStatusReasonData(props.tenant).then((response) => {
        setStatusReport(
          response.map((dom) => ({
            id: dom.code,
            descr: `${dom.code} - ${dom.descr}`,
          }))
        );
    });
	
	vehicleAction.getCarSegment(props.tenant).then((s: any) => setCarSegment(s.data));
    vehicleAction.getCarClass(props.tenant).then((c: any) => setCarClass(c.data));
    vehicleAction.getAcriss(props.tenant).then((response) => setAcriss(response));

    manipulateLoc
      .expectedEndLocation(props.tenant)
      .then((response) => setLocationValues(response));
  };

  const managerTractionData = (response: any) => {
    let values: any = [];
    if (response != null) {
      response.data.map((element: any) => {
        values.push({
          id: element.code,
          descr: element.descr,
        });
      });
    }
    return values;
  };
  
  const filteredClass = (filterData.carSegment.id ? carClass.filter((c: any) => c.carSegment.id === filterData.carSegment.id) : carClass);
  const filteredAcriss = (filterData.carClass.id ? acriss?.filter((element: any) => element?.carClass?.id === filterData.carClass.id) : acriss);


  useEffect(() => {
    resetData();
  }, [props.tenant]);

  useEffect(() => {
    endpointData();
  }, [i18n.language]);

  useEffect(() => {
    if(locationsLoading === true) {
      setLoading(true);
    } else{
      setLoading(false);
    }
  }, [locationsLoading]);

  return (
    <form id="idStatusReportForm" onSubmit={(e: any) => Search(e)}>
      <GenericFilterBox
        formId="idStatusReportForm"
        onReset={resetData}
        showExtrasFilters={!!filterData.referenceLocationId.id ? true : false}
        showResetAndSerchButton={
          !!filterData.referenceLocationId.id ? true : false
        }
      >
        <Box>
          <Autocomplete
            disablePortal
            sx={{
              "&.MuiAutocomplete-root": {
                "& button[title='Clear']": {
                  visibility: "visible",
                },
              },
            }}
            disableClearable={
              !!filterData.referenceLocationId.id ? false : true
            }
            id="referenceLocationId"
            value={{
              id: filterData.referenceLocationId.id,
              descr: filterData.referenceLocationId.descr,
            }}
            options={userLocations}
            getOptionLabel={(option: any) => option?.descr}
            renderOption={(props, option, state) => {
              return (
                <li {...props} key={option.id}>
                  {option.descr}
                </li>
              );
            }}
            onChange={(e, value) => {
              if (value === null) {
                resetData();
              } else {
                e.stopPropagation();
                handleChangePhysicalLocationType(value, "referenceLocationId");
              }
            }}
            renderInput={(params: any) => (
              <TextField
                fullWidth
                variant="standard"
                {...params}
                label={t("statusReport.filterAndSearch.referenceLocationId")}
              />
            )}
          />
        </Box>

        {!!filterData.referenceLocationId.id && (
          <>
            <Box>
              <TextField
                variant="standard"
                fullWidth
                id="plate"
                name="plate"
                value={filterData.plate}
                label={t("statusReport.filterAndSearch.plate")}
                onChange={(event) => handleChange(event)}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                variant="standard"
                fullWidth
                id="vin"
                name="vin"
                value={filterData.vin}
                label={t("statusReport.filterAndSearch.vin")}
                onChange={(event) => handleChange(event)}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={!!filterData.status.id ? false : true}
                id="status"
                value={{
                  id: filterData.status.id,
                  descr: filterData.status.descr,
                }}
                options={statusType}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangePhysicalLocationType(value, "status");
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t("statusReport.filterAndSearch.status")}
                  />
                )}
              />
            </Box>

            <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={filterData.carSegment.id ? false : true}
              id="carSegment"
              value={{ id: filterData.carSegment.id, descr: filterData.carSegment.descr }}
              options={carSegment.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (filterData.carSegment.id !== value?.id)
                handleChangeSpec(value, "carSegment");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectCarSegment")}
                />
              )}
            />
          </Box>

            
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={filterData.carClass.id ? false : true}
              id="carClass"
              value={{ id: filterData.carClass.id, descr: filterData.carClass.descr }}
              options={filteredClass.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (filterData.carClass.id !== value?.id)
                handleChangeSpec(value, "carClass");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectCarClass")}
                />
              )}
            />
          </Box>


          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={filterData.carAcriss.id ? false : true}
              id="carAcriss"
              value={{ id: filterData.carAcriss.id, code: filterData.carAcriss.code }}
              options={filteredAcriss.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.code}
              onChange={(e, value) => {
                if (filterData.carAcriss.id !== value?.id) {
                  handleChangeAcriss(value, "carAcriss");
                }
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.code}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectAcriss")}
                />
              )}
            />
          </Box>

            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={
                  !!filterData.checkinEstimatedLocationType.id ? false : true
                }
                id="checkinEstimatedLocationType"
                value={{
                  id: filterData.checkinEstimatedLocationType.id,
                  descr: filterData.checkinEstimatedLocationType.descr,
                }}
                options={checkinEstimatedLocationType}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangePhysicalLocationType(
                    value,
                    "checkinEstimatedLocationType"
                  );
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t(
                      "statusReport.filterAndSearch.physicalLocationType"
                    )}
                  />
                )}
              />
            </Box>

            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={!!filterData.statusReasons.id ? false : true}
                id="statusReasons"
                value={{
                  id: filterData.statusReasons.id,
                  descr: filterData.statusReasons.descr,
                  status: filterData.statusReasons.status,
                }}
                options={statusReport}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangePhysicalLocationType(value, "statusReasons");
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t("statusReport.filterAndSearch.statusReason")}
                  />
                )}
              />
            </Box>
            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={!!filterData.tractionType.id ? false : true}
                id="tractionType"
                value={{
                  id: filterData.tractionType.id,
                  descr: filterData.tractionType.descr,
                }}
                options={tractionValues}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangePhysicalLocationType(value, "tractionType");
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t("statusReport.table.tractionType")}
                  />
                )}
              />
            </Box>

            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={
                  !!filterData.checkinEstimatedLocationId.id ? false : true
                }
                id="checkinEstimatedLocationId"
                value={{
                  id: filterData.checkinEstimatedLocationId.id,
                  descr: filterData.checkinEstimatedLocationId.descr,
                }}
                options={locationValues}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangePhysicalLocationType(
                    value,
                    "checkinEstimatedLocationId"
                  );
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t(
                      "statusReport.filterAndSearch.expectedEndLocation"
                    )}
                  />
                )}
              />
            </Box>

            <Box>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="keyless-label">{t("statusReport.filterAndSearch.keyless")}</InputLabel>
                <Select
                    labelId="keyless-label"
                    id="keyless-label"
                    value={filterData.keyless}
                    onChange={(event) => setFilterData({...filterData, keyless: event.target.value})}
                >
                  <MenuItem value={''}></MenuItem>
                  <MenuItem value={0}>{t("statusReport.table.no")}</MenuItem>
                  <MenuItem value={1}>{t("statusReport.table.yes")}</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </>
        )}
      </GenericFilterBox>
    </form>
  );
};

export default StatusReportFilterAndSearch;
